import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts } from '../../../settings';
import { DelayLink } from '../../../components';

import './AtuacaoInternacional.scss';

class AtuacaoInternacional extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
    this.months = ['maio', 'setembro', 'outubro', 'novembro', 'dezembro'];
  }

  state = {
    cActive: 0,
  };

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  changeItem = index => {
    if (index >= 0 && index < this.months.length) {
      this.setState({ cActive: index });
    }
  };

  render = () => {
    const { cActive } = this.state;
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Atuação internacional - Iniciativas - {texts.title}</title>
        </Helmet>

        <div
          className="iniciativas-home atuacao-internacional-home page-gradient page-gradient--yellow bg-gray"
          ref="atuacao-internacional-home"
        >
          <section className="iniciativas-area atuacao-internacional-area page--yellow">
            <div className="container container--large">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--yellow">
                      <div className="card__content">
                        <div className="card__content__header">
                          <DelayLink
                            to="/estrategias/para-o-mercado"
                            className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Voltar
                          </DelayLink>
                          <h1 className="title title--gray">Atuação internacional </h1>
                        </div>
                        <div className="card__content__body">
                          <p>
                            Acompanhamos os movimentos da regulação e da autorregulação dos mercados ao redor do mundo,
                            além de participarmos ativamente de fóruns e eventos internacionais para troca de
                            informações relevantes ao cenário brasileiro.
                          </p>
                          <p>
                            Em 2019, lançamos uma publicação sobre novidades e alterações nas regulações dos Estados
                            Unidos, da União Europeia e do Reino Unido. Basta cadastrar um e-mail na nossa lista de
                            publicações para receber os comunicados.
                          </p>
                        </div>
                      </div>
                      {/* <div className="card__image">
                        <img src={images.iniciativas.raio_x.capa} />
                      </div> */}
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="atuacao-internacional-body">
            <div className="container container--large">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--no-border card--topics">
                      <div className="card__content card__content--full">
                        <div className="card__content__header">
                          <h3 className="title title--small yellow gri_text">
                            Confira os eventos em que marcamos presença:{' '}
                            <span className="gri_label light-gray">
                              GRI <b>102-13</b>
                            </span>
                          </h3>

                          <div className="atuacao__nav">
                            <div
                              className="c__nav__button c__nav__button--prev"
                              onClick={() => this.changeItem(cActive - 1)}
                            ></div>
                            <div
                              className="c__nav__button c__nav__button--next"
                              onClick={() => this.changeItem(cActive + 1)}
                            ></div>
                          </div>
                        </div>

                        <div className="card__content__body">
                          <div className="eventos">
                            <div className="row">
                              <div className="col-2">
                                <img src={images.icons.calendar_square_yellow} />

                                <ul className="options options--mobile">
                                  <li className={this.months[cActive] == 'maio' ? `active` : ``}>Maio</li>
                                  <li className={this.months[cActive] == 'setembro' ? `active` : ``}>Setembro</li>
                                  <li className={this.months[cActive] == 'outubro' ? `active` : ``}>Outubro</li>
                                  <li className={this.months[cActive] == 'novembro' ? `active` : ``}>Novembro</li>
                                  <li className={this.months[cActive] == 'dezembro' ? `active` : ``}>Dezembro</li>
                                </ul>
                              </div>

                              <div className="col-10">
                                <ul className="options">
                                  <li
                                    className={this.months[cActive] == 'maio' ? `active` : ``}
                                    onClick={() => this.setState({ cActive: 0 })}
                                  >
                                    Maio
                                  </li>
                                  <li
                                    className={this.months[cActive] == 'setembro' ? `active` : ``}
                                    onClick={() => this.setState({ cActive: 1 })}
                                  >
                                    Setembro
                                  </li>
                                  <li
                                    className={this.months[cActive] == 'outubro' ? `active` : ``}
                                    onClick={() => this.setState({ cActive: 2 })}
                                  >
                                    Outubro
                                  </li>
                                  <li
                                    className={this.months[cActive] == 'novembro' ? `active` : ``}
                                    onClick={() => this.setState({ cActive: 3 })}
                                  >
                                    Novembro
                                  </li>
                                  <li
                                    className={this.months[cActive] == 'dezembro' ? `active` : ``}
                                    onClick={() => this.setState({ cActive: 4 })}
                                  >
                                    Dezembro
                                  </li>
                                </ul>

                                <div className="content">
                                  {this.months[cActive] == 'maio' && (
                                    <div>
                                      <p>
                                        <strong>44ª Conferência da Iosco (Sydney, Austrália)</strong>
                                        <br />O evento discutiu as prioridades da Organização Internacional das
                                        Comissões de Valores Mobiliários para 2019, como criptoativos, uso de
                                        inteligência artificial, fragmentação de mercado, entre outras. Durante a
                                        conferência, participamos da reunião do AMCC (Comitê Consultivo de Membros
                                        Afiliados).{' '}
                                      </p>

                                      <p>
                                        <strong>Congresso da Finra (Washington, EUA)</strong>
                                        <br />O encontro da Autoridade Regulatória da Indústria Financeira dos Estados
                                        Unidos falou sobre as melhores práticas da autorregulação norte-americana, em
                                        especial sobre a automação de processos para atender às exigências de
                                        compliance. Também participamos do congresso para acompanhar o balanço do
                                        primeiro ano da certificação SIE (Securities Industry Essentials), uma
                                        qualificação básica para quem está entrando no mercado, e pegar insumos para as
                                        nossas certificações no Brasil.{' '}
                                      </p>

                                      <p>
                                        <strong>51ª Assembleia Geral e Conferência da ICMA (Estocolmo, Suécia)</strong>
                                        <br />
                                        Encontro da Associação Internacional de Mercado de Capitais debateu a emissão de
                                        títulos verdes, regras para uso de taxas financeiras e digitalização de títulos
                                        e processos durante o encontro da Associação Internacional de Mercado de
                                        Capitais.{' '}
                                      </p>

                                      <p>
                                        <strong>17º Seminário da Fiap (Santiago, Chile)</strong>
                                        <br />
                                        Discussão, durante evento da Federação Internacional de Administradores de
                                        Fundos de Pensão, sobre os impactos das novas gerações, das inovações
                                        tecnológicas e das transformações do mercado de trabalho sobre o sistema de
                                        pensão.
                                      </p>

                                      <p>
                                        <strong>
                                          Conferência Internacional de Educação Financeira da OCDE (Cidade do Cabo,
                                          África do Sul)
                                        </strong>
                                        <br />
                                        Presença em encontro promovido pela Organização para Cooperação e
                                        Desenvolvimento Econômico, que reúne reguladores, bancos centrais e
                                        autorreguladores de todo o mundo para troca de experiências. Os temas em pauta
                                        abordaram as necessidades em educação financeira para as diferentes faixas
                                        etárias, como implementar projetos em tempos de maior acesso à informação e às
                                        novas tecnologias, as implicações da digitalização, entre outros.
                                      </p>

                                      <p>
                                        <strong>
                                          Reuniões com CFP Board e CFA Institute (Charlottesville, Estados Unidos)
                                        </strong>
                                        <br />
                                        Conhecemos as instituições e entendemos como funcionam a CFP (Certified
                                        Financial Planner) e a CFA (Chartered Financial Analyst) em outros países. A
                                        partir da troca de melhores práticas, o contato serviu como inspiração para
                                        avaliar possíveis melhorias nas nossas certificações.{' '}
                                      </p>
                                    </div>
                                  )}

                                  {this.months[cActive] == 'setembro' && (
                                    <div>
                                      <p>
                                        <strong>Encontro semestral do SMPG (Bruxelas, Bélgica) </strong>
                                        <br />A reunião semestral do Grupo de Padronização de Práticas de Mercado tratou
                                        da padronização na troca de mensageria ISO para investimentos, com foco no
                                        mercado de fundos.
                                      </p>

                                      <p>
                                        <strong>
                                          Reunião do capítulo das Américas do Ifie (São Petersburgo, Rússia){' '}
                                        </strong>
                                        <br />
                                        Coordenação das reuniões do capítulo das Américas, grupo do Fórum Internacional
                                        de Educação de Investidores que reúne os países da região para debate de
                                        melhores práticas em educação financeira e para troca de experiências
                                        relacionadas aos projetos desenvolvidos por cada um. O encontro contou também
                                        com uma reunião do board do Ifie, que integramos, para falar sobre o andamento
                                        das iniciativas e coordenar a agenda para 2020.
                                      </p>
                                    </div>
                                  )}

                                  {this.months[cActive] == 'outubro' && (
                                    <div>
                                      <p>
                                        <strong>33ª Conferência da IIFA (Buenos Aires, Argentina)</strong>
                                        <br />
                                        Durante evento da Associação Internacional de Fundos de Investimento, fizemos
                                        apresentações sobre o uso dos critérios ASG (ambientais, sociais e de
                                        governança) na indústria de gestão de recursos e sobre educação e inclusão
                                        financeira.
                                      </p>
                                    </div>
                                  )}

                                  {this.months[cActive] == 'novembro' && (
                                    <div>
                                      <p>
                                        <strong>Assembleia anual da Fiafin (Cidade do México, México) </strong>
                                        <br />
                                        Participação, via teleconferência, do evento que discutiu o plano de ação da
                                        Federação Ibero-Americana de Fundos de Investimento para 2020, bem como os
                                        objetivos que devem ser alcançados pela indústria como um todo.
                                      </p>

                                      <p>
                                        <strong>Reuniões Iarc e Cosra (Buenos Aires, Argentina)</strong>
                                        <br />
                                        Encontro do Iarc (Comitê Regional Interamericano da Iosco), que ocorre junto com
                                        a reunião do Cosra (Conselho de Reguladores das Américas), grupo do qual fazemos
                                        parte. Na ocasião, os participantes trataram das pautas da regulação, das
                                        iniciativas em sustentabilidade no mercado de capitais e do uso de criptoativos.
                                      </p>

                                      <p>
                                        <strong>3ª Conferência anual da AFME (Paris, França) </strong>
                                        <br />
                                        Discussão sobre os impactos da tecnologia e da inovação nos mercados de capitais
                                        europeus em encontro da Associação para Mercados Financeiros na Europa. O debate
                                        falou sobre inteligência artificial, computação em nuvem, ativos digitais e como
                                        os reguladores podem aproveitar essas oportunidades.{' '}
                                      </p>
                                    </div>
                                  )}

                                  {this.months[cActive] == 'dezembro' && (
                                    <div>
                                      <p>
                                        <strong>Reunião semestral do AMCC (Madri, Espanha) </strong>
                                        <br />A pauta do encontro do Comitê Consultivo de Membros Afiliados da Iosco
                                        tratou de uso de inteligência artificial e machine learning, fintechs e
                                        sustentabilidade. Foram abordadas, ainda, as iniciativas tocadas pelo grupo para
                                        contribuir para os temas prioritários da agenda da Iosco, como regulação de
                                        fundos e cibersegurança. Também participamos do 12º treinamento para reguladores
                                        sobre os princípios da Iosco, no qual fizemos uma apresentação em um painel
                                        sobre regulação de derivativos.
                                      </p>
                                    </div>
                                  )}

                                  <p>
                                    <DelayLink
                                      to="/relacionamentos"
                                      className="text_link text_link--yellow text_link--no-underline"
                                    >
                                      Saiba mais sobre nosso relacionamento com diversas dessas entidades
                                    </DelayLink>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { AtuacaoInternacional };
